import React from "react";
import { Routes, Route } from "react-router-dom";
import ListAds from "../Components/Ads,Banners/listAds";
import AddAdsBanners from "../Components/Ads,Banners/addAdsBanners";
import EditAdsBanners from "../Components/Ads,Banners/EditBanners";

const BannerAdsRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/ads,_banner" element={<ListAds></ListAds>}></Route>
        <Route
          path="/ads,_banner/add"
          element={<AddAdsBanners></AddAdsBanners>}
        ></Route>
        <Route path="/ads,_banner/edit/:id" element={<EditAdsBanners />} />
      </Routes>
    </div>
  );
};

export default BannerAdsRoutes;
